// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Uuid from "../../externals/Uuid.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as CatalogProduct from "./CatalogProduct.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function encoder(param) {
  return [
    param.id,
    param.value
  ];
}

function decoder(param) {
  let uuid = Uuid.fromString(param[0]);
  if (uuid !== undefined) {
    return {
      TAG: "Ok",
      _0: {
        id: Primitive_option.valFromOption(uuid),
        value: param[1]
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: {
        NAME: "SyntaxError",
        VAL: "Invalid tax uuid"
      }
    };
  }
}

let value = JsonCodec.object2(encoder, decoder, JsonCodec.field("id", JsonCodec.string), JsonCodec.field("value", JsonCodec.float));

let Tax = {
  encoder: encoder,
  decoder: decoder,
  value: value
};

function encoder$1(state) {
  return [
    state.name,
    state.tax,
    Stdlib_Option.map(state.categoryId, prim => prim),
    CatalogProduct.Kind.toString(state.kind),
    Stdlib_Option.map(state.color, CatalogProduct.Color.toString),
    state.producer,
    state.family,
    state.designation,
    state.country,
    state.region,
    state.beerType,
    Stdlib_Option.map(state.wineType, CatalogProduct.WineType.toString),
    Stdlib_Option.map(state.whiteWineType, CatalogProduct.WhiteWineType.toString)
  ];
}

function decoder$1(param) {
  let getValueAndError = value => {
    if (value !== undefined) {
      if (value.TAG === "Ok") {
        return [
          Primitive_option.some(value._0),
          undefined
        ];
      } else {
        return [
          undefined,
          Primitive_option.some(value._0)
        ];
      }
    } else {
      return [
        undefined,
        undefined
      ];
    }
  };
  let categoryId = Stdlib_Option.map(param[2], id => {
    let uuid = Uuid.fromString(id);
    if (uuid !== undefined) {
      return {
        TAG: "Ok",
        _0: Primitive_option.valFromOption(uuid)
      };
    } else {
      return {
        TAG: "Error",
        _0: "Invalid category uuid"
      };
    }
  });
  let match = CatalogProduct.Kind.fromString(param[3]);
  let match$1 = getValueAndError(categoryId);
  let match$2 = getValueAndError(Stdlib_Option.map(param[4], CatalogProduct.Color.fromString));
  let match$3 = getValueAndError(Stdlib_Option.map(param[11], CatalogProduct.WineType.fromString));
  let match$4 = getValueAndError(Stdlib_Option.map(param[12], CatalogProduct.WhiteWineType.fromString));
  if (match.TAG !== "Ok") {
    return {
      TAG: "Error",
      _0: {
        NAME: "SyntaxError",
        VAL: match._0
      }
    };
  }
  if (match$1[1] === undefined && match$2[1] === undefined && match$3[1] === undefined && match$4[1] === undefined) {
    return {
      TAG: "Ok",
      _0: {
        name: param[0],
        kind: match._0,
        color: match$2[0],
        tax: param[1],
        categoryId: match$1[0],
        producer: param[5],
        family: param[6],
        designation: param[7],
        country: param[8],
        region: param[9],
        beerType: param[10],
        wineType: match$3[0],
        whiteWineType: match$4[0]
      }
    };
  }
  let error = match$1[1];
  if (error !== undefined) {
    return {
      TAG: "Error",
      _0: {
        NAME: "SyntaxError",
        VAL: error
      }
    };
  }
  let error$1 = match$2[1];
  if (error$1 !== undefined) {
    return {
      TAG: "Error",
      _0: {
        NAME: "SyntaxError",
        VAL: error$1
      }
    };
  }
  let error$2 = match$3[1];
  if (error$2 !== undefined) {
    return {
      TAG: "Error",
      _0: {
        NAME: "SyntaxError",
        VAL: error$2
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: {
        NAME: "SyntaxError",
        VAL: match$4[1]
      }
    };
  }
}

let value$1 = JsonCodec.object13(encoder$1, decoder$1, JsonCodec.field("name", JsonCodec.string), JsonCodec.optional(JsonCodec.field("tax", value)), JsonCodec.optional(JsonCodec.field("categoryId", JsonCodec.string)), JsonCodec.field("kind", JsonCodec.string), JsonCodec.optional(JsonCodec.field("color", JsonCodec.string)), JsonCodec.field("producer", JsonCodec.string), JsonCodec.field("family", JsonCodec.string), JsonCodec.field("designation", JsonCodec.string), JsonCodec.field("country", JsonCodec.string), JsonCodec.field("region", JsonCodec.string), JsonCodec.field("beerType", JsonCodec.string), JsonCodec.optional(JsonCodec.field("wineType", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("whiteWineType", JsonCodec.string)));

let Codecs = {
  Tax: Tax,
  encoder: encoder$1,
  decoder: decoder$1,
  value: value$1
};

function encode(state) {
  return JsonCodec.encodeWith(state, value$1);
}

function decode(historyState) {
  return Stdlib_Option.map(historyState, state => JsonCodec.decodeWith(state, value$1));
}

let CreateVariantFromProduct = {
  Codecs: Codecs,
  encode: encode,
  decode: decode
};

export {
  CreateVariantFromProduct,
}
/* value Not a pure module */
